export enum SellerState {
	Active = 1,
	Inactive = 0,
}
